<template>
  <v-row>
    <v-col
      cols="12"
      sm="12"
      style="padding: 20px 50px 0 50px;"
    >
      <br/>
      <list-activities />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      style="padding: 20px 50px 20px 50px;"
    >
      <export-events />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      style="padding: 0 50px;"
    >
      <export-manager />
      <br />
      <br />
    </v-col>
  </v-row>
</template>
<script>
import ExportManager from './ExportManager'
import ExportEvents from './ExportEvents'
import ListActivities from './ListActivities'
export default {
  components: {
    ExportManager,
    ExportEvents,
    ListActivities,
  },
}
</script>

